import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { Form } from '@sparefoot/react-core';
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose';

import { Button } from 'components/core/Button';
import { GoogleAutocomplete } from 'components/core/GoogleAutocomplete';
import Marker from 'components/svg/Marker';

import './SearchBox.scss';

export const enhance = compose(
	withStateHandlers(
		({ location }) => ({ locationParams: { location }, instance: null }),
		{
			handleGoogle: () => (locationParams) => ({ locationParams }),
			getRef: () => (instance) => ({ instance })
		}
	),
	withHandlers({
		handleSearch: ({ handleGoogle, instance, locationParams, onSearch }) => (event) => {
			event.preventDefault();

			let searchParams = locationParams;

			// use the inputs value if not selected from autocomplete
			if (!locationParams.locationSource && instance && (instance.value !== 'undefined')) {
				searchParams = { location: instance.value };
			}

			handleGoogle(searchParams);

			return onSearch({ locationParams: searchParams });
		}
	}),
	lifecycle({
		componentDidUpdate(prevProps) {
			const { autoSearch, handleGoogle, onSearch, location, locationParams } = this.props;
			if (!isEqual(location, prevProps.location)) {
				handleGoogle({ location });
			}

			if (autoSearch && !isEqual(locationParams, prevProps.locationParams) && locationParams.locationSource) {
				onSearch({ locationParams });
			}
		}
	})
);

export function SearchBox({
	buttonText, handleSearch, handleGoogle, id,
	inputLabel, getRef, locationParams, useBrowserLocation
}) {
	return (
		<Form
			action="/search"
			className="search-box"
			successLabel="success"
			failureLabel="fail"
			onSubmit={handleSearch}
		>
			<Marker />
			<GoogleAutocomplete
				segmentLabel="location input field"
				placeholder={inputLabel}
				className="location-input"
				onChange={handleGoogle}
				getRef={getRef}
				id={id}
				value={locationParams.location}
				name="location"
				useBrowserLocation={useBrowserLocation}
			/>
			<Button
				primary
				type="submit"
				segmentLabel="facility search button"
				className="search-button"
			>
				{buttonText}
			</Button>
		</Form>
	);
}

SearchBox.propTypes = {
	getRef: PropTypes.func,
	handleGoogle: PropTypes.func.isRequired,
	handleSearch: PropTypes.func.isRequired,
	id: PropTypes.string,
	inputLabel: PropTypes.string,
	locationParams: PropTypes.shape({
		location: PropTypes.string
	}),
	buttonText: PropTypes.string,
	useBrowserLocation: PropTypes.bool
};

SearchBox.defaultProps = {
	buttonText: 'Find Units'
};

export default enhance(SearchBox);
